import { useCallback } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import TwinForm from '../../../../../../forms/TwinForm'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../forms/TwinForm/types'
import withLoading from '../../../../../../utils/hoc/withLoading'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { LabelsPayload } from '../../../../../../utils/reducers/company/labels'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import { CustomSelectWithSearchBar } from '../../../../../../forms/CustomSelect'
import { InputHidden, InputWithLabelMarginIntegerStateFull } from '../../../../../../forms/Input'
import { twinFetchPostPrinter } from '../../../../../../utils/globals/data'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import './modalPrintWorkSheetTags.sass'

type ModalPrintWorkSheetTagsProps = ModalEditComponentProps & ReduxModalPrintWorkSheetTags & {
}

const ModalPrintWorkSheetTags: React.FC<ModalPrintWorkSheetTagsProps> = ({labels, specificPriceRules, ...logic}) => {
    const { loading, onPreSubmit, onSubmit } = useModalPrintWorkSheetTagsLogic({ ...logic })
    const {t} = useTwinTranslation()
    return (
        <ModalSmallCentered opened={true} setOpened={logic.setOpened} onClickOut={false} className='modal_print_worksheet_tags text-gray-51 regular14 flex_height skip_width_fields'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action={'/api/app/order/sell/workSheet/printWorkSheetLabels'} onSubmit={onSubmit} className='flex flex-auto flex-col justify-between gap-y-10 ' triggerErrors={false} triggerSuccess={false}>
                <CustomSelectWithSearchBar items={labels || {}} label={t('tag', 'Etiqueta')} value={logic.allRowData?.LabelId || Object.keys(labels || {})?.[0] || ''} name='LabelId' required={true}/>
                <CustomSelectWithSearchBar items={specificPriceRules?.dictionary || {}} label={t('specificPriceRule', 'Tarifa')} value={logic.allRowData?.SpecificPriceRuleId || specificPriceRules?.arrSorted?.[0]?.id || ''} name='SpecificPriceRuleId' required={true}/>
                <InputWithLabelMarginIntegerStateFull className='text-start w-full' label={t('tagQuantity', 'Cantidad de etiquetas')} minValue={1} defaultValue={String(logic.allRowData?.tagQuantity)} name='tagQuantity' />
                <InputHidden name='id' value={logic.allRowData?.id}/>
                <ButtonsModalSmallCentered confirmText={t('print', 'Imprimir')} setOpened={() => {}} onCancel={() => logic.setOpened(null)} loading={loading}/>
            </TwinForm>
        </ModalSmallCentered>
    )
}

interface ModalPrintWorkSheetTagsLogicProps {
    allRowData?: RowData
    setOpened: ModalOpenedSetTy
}

const useModalPrintWorkSheetTagsLogic = ({ setOpened, allRowData }: ModalPrintWorkSheetTagsLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const { t } = useTwinTranslation()
    const errorMessage = t('couldNotConnectWithPrinter', 'No se ha podido conectar con la impresora')
    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        vals.extraProductsWhere = { id: allRowData?.WorkSheetProductId }
        startLoading()
        return true
    }, [startLoading, allRowData?.WorkSheetProductId])

    const onSubmit: OnSubmit = useCallback(async (result) => {
         if(result && result.status === 367){
            const body = await result.json()
             const myresult = await twinFetchPostPrinter('/printLabel', body, errorMessage)
             if (myresult) {
                 setOpened(null)
             }
        }
        endLoading()
    }, [endLoading, setOpened, errorMessage])
    return { onPreSubmit, onSubmit, loading, endLoading }
}

const modalPrintTagsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
    setLabels: (payload: LabelsPayload) => ({ type: 'CHANGE_LABELS', payload }),
}

type ReduxModalPrintWorkSheetTags = ConnectedProps<typeof modalPrintWorkSheetTagsConnect>
const mapModalPrintWorkSheetTagsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules, labels: state.labels })
const modalPrintWorkSheetTagsConnect = connect(mapModalPrintWorkSheetTagsConnector, modalPrintTagsDispatch)

const modalPrintWorkSheetTagsConnectLoading = withLoading(ModalPrintWorkSheetTags, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/config/label/getAllLabels', propName: 'labels', setFunctionName: 'setLabels' }])
const ModalPrintWorkSheetTagsConnect = modalPrintWorkSheetTagsConnect(modalPrintWorkSheetTagsConnectLoading)

export default ModalPrintWorkSheetTagsConnect